import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "@/state/store";
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from "@/plugins/i18n.js";
import "@/assets/tailwind.css";
// Globally register all `_base`-prefixed components
import "@/components/global/_globals";

// load layout
import LayoutDefault from "./layouts/LayoutDefault.vue";
Vue.component("LayoutDefault", LayoutDefault);
// for development load the components manually so it does not break with the devtool open
//https://github.com/vuejs/vue-devtools/issues/944 - vue-devtools issue
import LayoutError from "./layouts/LayoutError.vue";
Vue.component("LayoutError", LayoutError);
import LayoutLogged from "./layouts/LayoutLogged.vue";
Vue.component("LayoutLogged", LayoutLogged);
import LayoutLogin from "./layouts/LayoutLogin.vue";
Vue.component("LayoutLogin", LayoutLogin);
// end layout

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import "./plugins/date-filter.js";
// import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);

Vue.config.productionTip = false;

// const HTTP = require("@/api/http.js");
// Vue.prototype.$http = HTTP;

//Custom settings file
const system_config = require("@/constants/config.json");
Vue.prototype.$system_config = system_config;

//Axios
axios.defaults.baseURL = process.env.VUE_APP_NKRSYNC_BE;
Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
